import React, { useEffect, useState } from "react";
import { useParams, useHistory } from "react-router-dom";
import Header from "./../../Shared/Components/Header/Header";
import Modal from "../../Shared/Components/Modal/Modal";
import GroupAssignments from "./Components/GroupAssignments";
import GroupUserManagement from "./Components/GroupUserManagement";
import { showToast } from "../../Infrastructure/Notifications/ToastrConfig";
import { getGroupDetailsAsync } from "../../Services/ClientService";
import { ADMIN, userIsInRole } from "../../Services/AuthService";

const Group = () => {
  const { urlToken, groupId } = useParams();
  const history = useHistory();
  const isAdmin = userIsInRole(ADMIN);
  const [group, setGroup] = useState({
    id: "",
    clientId: "",
    name: "",
    description: "",
    users: [{ id: "", firstName: "", lastName: "", email: "" }],
    courses: [],
    learningPathways: [],
  });

  const refreshGroup = async () => {
    const response = await getGroupDetailsAsync(groupId);
    setGroup({
      id: groupId,
      clientId: response.clientId || "",
      name: response.name,
      description: response.description,
      users: response.users || [],
      courses: response.courses || [],
      learningPathways: response.learningPathways || [],
    });
  };
  const [isEditMode, setIsEditMode] = useState(false);
  const [editedGroup, setEditedGroup] = useState({ name: "", description: "" });

  useEffect(() => {
    refreshGroup();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupId]);

  const handleEditToggle = () => {
    if (!isEditMode) {
      setEditedGroup({ name: group.name, description: group.description });
    }
    setIsEditMode(!isEditMode);
  };

  const saveGroupChanges = async () => {
    // TODO: Implement API call to update group
    // const response = await updateGroupAsync({ groupId: group.id, ...editedGroup });
    // if (response.success) {
    showToast(true, "Group updated successfully");
    setGroup({ ...group, ...editedGroup });
    setIsEditMode(false);
    // } else {
    //     showToast(false, "Failed to update group");
    // }
  };

  const deleteGroup = async () => {
    // TODO: Implement API call to delete group
    // const response = await deleteGroupAsync(groupId);
    // if (response.success) {
    showToast(true, "Group deleted successfully");
    history.push(`/client/${urlToken}`);
    // } else {
    //     showToast(false, "Failed to delete group");
    // }
  };

  return (
    <>
      <Modal
        modalId="deleteGroupModal"
        bodyText={`Are you sure you want to delete ${group.name}? This action cannot be undone.`}
        buttonFunc={deleteGroup}
        buttonText="Delete Group"
        title="Delete Group"
      />

      <Header heading={group.name} icon="people" />
      <div
        className="container-fluid content"
        style={{
          minHeight: "100vh",
          padding: "40px",
        }}
      >
        <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
          {/* Group Details Section */}
          <div
            style={{
              background: "white",
              borderRadius: "20px",
              padding: "32px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
              border: "1px solid rgba(0,0,0,0.05)",
              marginBottom: "24px",
            }}
          >
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                marginBottom: "24px",
              }}
            >
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: "#1e293b",
                  borderBottom: "3px solid #667eea",
                  paddingBottom: "12px",
                  margin: 0,
                }}
              >
                📝 Group Details
              </h3>
              <div style={{ display: "flex", gap: "12px" }}>
                {isEditMode ? (
                  <>
                    <button
                      onClick={() => setIsEditMode(false)}
                      style={{
                        background: "#6b7280",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        padding: "10px 20px",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                        cursor: "pointer",
                        transition: "all 0.3s",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      onClick={saveGroupChanges}
                      style={{
                        background:
                          "linear-gradient(135deg, #10b981 0%, #059669 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        padding: "10px 20px",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(16, 185, 129, 0.25)",
                        transition: "all 0.3s",
                      }}
                    >
                      Save Changes
                    </button>
                  </>
                ) : (
                  <>
                    <button
                      onClick={handleEditToggle}
                      style={{
                        background:
                          "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        padding: "10px 20px",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(59, 130, 246, 0.25)",
                        transition: "all 0.3s",
                      }}
                    >
                      ✏️ Edit Group
                    </button>
                    <button
                      data-target="#deleteGroupModal"
                      data-toggle="modal"
                      style={{
                        background:
                          "linear-gradient(135deg, #ef4444 0%, #dc2626 100%)",
                        color: "white",
                        border: "none",
                        borderRadius: "8px",
                        padding: "10px 20px",
                        fontSize: "0.9rem",
                        fontWeight: "600",
                        cursor: "pointer",
                        boxShadow: "0 4px 12px rgba(239, 68, 68, 0.25)",
                        transition: "all 0.3s",
                      }}
                    >
                      🗑️ Delete Group
                    </button>
                  </>
                )}
              </div>
            </div>

            {isEditMode ? (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div>
                  <label
                    style={{
                      display: "block",
                      fontSize: "0.9rem",
                      fontWeight: "600",
                      color: "#64748b",
                      marginBottom: "8px",
                    }}
                  >
                    Group Name
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    value={editedGroup.name}
                    onChange={(e) =>
                      setEditedGroup({ ...editedGroup, name: e.target.value })
                    }
                    style={{
                      padding: "12px 16px",
                      fontSize: "1rem",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                    }}
                  />
                </div>
                <div>
                  <label
                    style={{
                      display: "block",
                      fontSize: "0.9rem",
                      fontWeight: "600",
                      color: "#64748b",
                      marginBottom: "8px",
                    }}
                  >
                    Description
                  </label>
                  <textarea
                    className="form-control"
                    value={editedGroup.description}
                    onChange={(e) =>
                      setEditedGroup({
                        ...editedGroup,
                        description: e.target.value,
                      })
                    }
                    rows="3"
                    style={{
                      padding: "12px 16px",
                      fontSize: "1rem",
                      border: "2px solid #e5e7eb",
                      borderRadius: "8px",
                    }}
                  />
                </div>
              </div>
            ) : (
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "16px",
                }}
              >
                <div>
                  <div
                    style={{
                      fontSize: "0.85rem",
                      color: "#64748b",
                      fontWeight: "600",
                      marginBottom: "4px",
                      textTransform: "uppercase",
                    }}
                  >
                    Group Name
                  </div>
                  <div
                    style={{
                      fontSize: "1.1rem",
                      color: "#1e293b",
                      fontWeight: "600",
                    }}
                  >
                    {group.name}
                  </div>
                </div>
                <div>
                  <div
                    style={{
                      fontSize: "0.85rem",
                      color: "#64748b",
                      fontWeight: "600",
                      marginBottom: "4px",
                      textTransform: "uppercase",
                    }}
                  >
                    Description
                  </div>
                  <div style={{ fontSize: "1rem", color: "#475569" }}>
                    {group.description}
                  </div>
                </div>
              </div>
            )}
          </div>

          {/* Group Course & Pathway Assignments - Admin only */}
          {isAdmin && (
            <div
              style={{
                background: "white",
                borderRadius: "20px",
                padding: "32px",
                boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
                border: "1px solid rgba(0,0,0,0.05)",
                marginBottom: "24px",
              }}
            >
              <h3
                style={{
                  fontSize: "1.5rem",
                  fontWeight: "700",
                  color: "#1e293b",
                  marginBottom: "24px",
                  borderBottom: "3px solid #667eea",
                  paddingBottom: "12px",
                }}
              >
                📚 Assigned Content
              </h3>
              <GroupAssignments
                groupId={groupId}
                assignedCourses={group.courses}
                assignedPathways={group.learningPathways}
                onUpdate={refreshGroup}
              />
            </div>
          )}

          {/* Group Users Section */}
          <div
            style={{
              background: "white",
              borderRadius: "20px",
              padding: "32px",
              boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
              border: "1px solid rgba(0,0,0,0.05)",
            }}
          >
            <GroupUserManagement
              groupId={groupId}
              clientId={group.clientId}
              users={group.users}
              onUpdate={refreshGroup}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Group;
